var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDiagramSubtask = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 2.5C1.80964 2.5 1.25 3.05964 1.25 3.75V7.5C1.25 8.19036 1.80964 8.75 2.5 8.75H17.5C18.1904 8.75 18.75 8.19036 18.75 7.5V3.75C18.75 3.05964 18.1904 2.5 17.5 2.5H2.5ZM3.125 3.75C2.77982 3.75 2.5 4.02982 2.5 4.375V6.875C2.5 7.22018 2.77982 7.5 3.125 7.5H16.875C17.2202 7.5 17.5 7.22018 17.5 6.875V4.375C17.5 4.02982 17.2202 3.75 16.875 3.75H3.125Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 11.25C8.05964 11.25 7.5 11.8096 7.5 12.5V16.25C7.5 16.9404 8.05964 17.5 8.75 17.5H17.5C18.1904 17.5 18.75 16.9404 18.75 16.25V12.5C18.75 11.8096 18.1904 11.25 17.5 11.25H8.75ZM9.375 12.5C9.02982 12.5 8.75 12.7798 8.75 13.125V15.625C8.75 15.9702 9.02982 16.25 9.375 16.25H16.875C17.2202 16.25 17.5 15.9702 17.5 15.625V13.125C17.5 12.7798 17.2202 12.5 16.875 12.5H9.375Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.75H3.75V13.75C3.75 14.4404 4.30964 15 5 15H7.5V13.75H5.625C5.27982 13.75 5 13.4702 5 13.125V8.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDiagramSubtask);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/diagram-subtask.16f1e8d1c99446cf273d8469fc9cf52f.svg";